import "./adminMiddle.css"

export default function AdminMiddle() {
  return (
    <div className="adminmiddle">AdminMiddle</div>
  )
}
